import { useEffect, useState } from "react";
import { getAllSalarySlip, getIncentiveList } from "../Services/PayrollService";

  
 
export const MyPayslips = ({ showTab , hideAmount }) => {
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const payslipData = {
    '2024-25': [
      { mon: 'Mar', yr: '2025', days: 31, awd: 28, gross: 118977, ded: 17665, net: 101312 },
      { mon: 'Feb', yr: '2025', days: 28, awd: 28, gross: 118977, ded: 17665, net: 101312 },
      { mon: 'Jan', yr: '2025', days: 31, awd: 28, gross: 118977, ded: 17665, net: 101312 },
      { mon: 'Dec', yr: '2024', days: 31, awd: 31, gross: 138977, ded: 21665, net: 117312 },
      { mon: 'Nov', yr: '2024', days: 30, awd: 28, gross: 118977, ded: 17665, net: 101312 },
      { mon: 'Oct', yr: '2024', days: 31, awd: 28, gross: 118977, ded: 17665, net: 101312 },
      { mon: 'Sep', yr: '2024', days: 30, awd: 30, gross: 118977, ded: 17665, net: 101312 },
      { mon: 'Aug', yr: '2024', days: 31, awd: 28, gross: 118977, ded: 17665, net: 101312 },
      { mon: 'Jul', yr: '2024', days: 31, awd: 29, gross: 114830, ded: 17200, net: 97630 },
      { mon: 'Jun', yr: '2024', days: 30, awd: 28, gross: 118977, ded: 17665, net: 101312 },
      { mon: 'May', yr: '2024', days: 31, awd: 28, gross: 118977, ded: 17665, net: 101312 },
      { mon: 'Apr', yr: '2024', days: 30, awd: 30, gross: 118977, ded: 17665, net: 101312 },
    ],
    '2023-24': [
      { mon: 'Mar', yr: '2024', days: 31, awd: 31, gross: 112000, ded: 16400, net: 95600 },
      { mon: 'Feb', yr: '2024', days: 29, awd: 28, gross: 109500, ded: 16000, net: 93500 },
      { mon: 'Jan', yr: '2024', days: 31, awd: 28, gross: 109500, ded: 16000, net: 93500 },
      { mon: 'Dec', yr: '2023', days: 31, awd: 31, gross: 125000, ded: 19000, net: 106000 },
      { mon: 'Nov', yr: '2023', days: 30, awd: 28, gross: 109500, ded: 16000, net: 93500 },
      { mon: 'Oct', yr: '2023', days: 31, awd: 28, gross: 109500, ded: 16000, net: 93500 },
    ],
    '2022-23': [
      { mon: 'Mar', yr: '2023', days: 31, awd: 31, gross: 98000, ded: 14500, net: 83500 },
      { mon: 'Feb', yr: '2023', days: 28, awd: 28, gross: 95000, ded: 14000, net: 81000 },
    ],
  };
const [selectedFY, setSelectedFY] = useState('2024-25');
const currentPayslips = payslipData[selectedFY] || payslipData['2024-25'];

useEffect(() => {
fetchPayslipList();
}, [])

 async function fetchPayslipList  () {
    // const req = {
    //   LoanId: 0,
    //   LoggedInEmpId: userDetails.EmpId || 0,
    //   OrgId: userDetails.OrgId || 0,
    //   GUID: "",
    //   EmpId: userDetails.EmpId || 0,
    //   PageNumber: 1,
    //   PageSize: 25,
    //   Search: "",
    //   LoanStatusId: "",
    //   LoanTypeId: "",
    // };

    try {
      const response = await getAllSalarySlip();

      console.log(response, "response-----------");
    } catch (error) {
      console.error("Error fetching payslip list:", error);
    }
  }

 const renderAmt = (value) => {
         return hideAmount ? "•••••" : `₹${value.toLocaleString("en-IN")}`;
    // if (masked) {
    //   return <span style={{ letterSpacing: '2px' }}>••••••</span>;
    // }
    // return `₹${value.toLocaleString('en-IN')}`;
  };



    return (
        <div className="tab-panel active" id="tab-payslips">
          <div className="sec-card">
            <div className="sec-card-head">
              <i className="fa-regular fa-file-lines text-brand" />
              <h6>My Payslips</h6>
              <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px', alignItems: 'center' }}>
                <select
                  className="form-select"
                  style={{ width: '120px', fontSize: '12px' }}
                  value={selectedFY}
                  onChange={(e) => setSelectedFY(e.target.value)}
                >
                  <option value="2024-25">FY 2024–25</option>
                  <option value="2023-24">FY 2023–24</option>
                  <option value="2022-23">FY 2022–23</option>
                </select>
              </div>
            </div>
            <div className="sec-card-body p0">
              {currentPayslips.map((p, i) => (
                <div key={i} className="payslip-row">
                  <div className="ps-mon-badge">
                    <div className="ps-mon">{p.mon}</div>
                    <div className="ps-yr">{p.yr}</div>
                  </div>
                  <div className="ps-details">
                    <div className="ps-name">
                      {p.mon} {p.yr} Payslip
                    </div>
                    <div className="ps-sub">
                      {p.days} days &nbsp;&bull;&nbsp; AWD {p.awd} &nbsp;&bull;&nbsp; Gross 
                      {renderAmt(p.gross)} &nbsp;&bull;&nbsp; Deductions 
                      {renderAmt(p.ded)}
                    </div>
                  </div>
                  <div className="ps-net">{renderAmt(p.net)}</div>
                  <span className="badge badge-paid" style={{ fontSize: '11px' }}>
                    <i className="fa-solid fa-check" /> Disbursed
                  </span>
                  <div style={{ display: 'flex', gap: '6px' }} className="no-print">
                    <button className="btn btn-light btn-sm" onClick={() => alert(`Viewing payslip: ${p.mon} ${p.yr}`)}>
                      <i className="fa-solid fa-eye" /> View
                    </button>
                    <button className="btn btn-light btn-sm">
                      <i className="fa-solid fa-file-pdf" /> PDF
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
            )
            }

            export default MyPayslips;